import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { RootState } from './index';
import { getMyInfo } from 'api/myProfile';

const initialState: any = {};

export const getUserInfo = createAsyncThunk('user/get', async (_, { rejectWithValue }) => {
  try {
    const response = await getMyInfo();
    return response.data;
  } catch (error: any) {
    return rejectWithValue(error.response.data.message);
  }
});

const userStore = createSlice({
  name: 'user',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getUserInfo.fulfilled, (state, action) => {
      state.user = action.payload.data;
    });
  },
});

export const selectUser = (state: RootState) => state.user;

export const selectUserDocuments = (state: RootState) => state.user?.user?.documents || [];

export const selectCanWithdraw = (state: RootState) => {
  const { user } = state.user;
  const isWithdrawVerificationRequired = state.payments.LK_WITHDRAW_VERIFICATION_REQUIRED;

  if (isWithdrawVerificationRequired === 0) return true;

  if (user.kyc_status === 'approved') return true;

  console.log('user', user);

  const newDocsCount = user.documents?.filter((doc: any) => doc.status === 'new').length || 0;

  return newDocsCount >= 2;
};

export const selectNeedVerificationAlert = (state: RootState) => {
  const isWithdrawVerificationRequired = state.payments.LK_WITHDRAW_VERIFICATION_REQUIRED;
  const canWithdraw = selectCanWithdraw(state);

  return isWithdrawVerificationRequired === 1 && !canWithdraw;
};

export const userReducer = userStore.reducer;
